import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentVerifiedOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M17.773 9 16.5 7.727l-6 6-3-3L6.227 12l4.273 4.273z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 23H3V1h10c6 0 8 2 8 8zM4.8 21.2V2.8H13c2.9 0 4.261.507 4.977 1.223S19.2 6.1 19.2 9v12.2z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentVerifiedOutlinedSize24Glyph.displayName = 'DocumentVerifiedOutlinedSize24Glyph';
